import Api from 'api';
import { cookies as cookiesStore } from 'store';
import { getCookie } from 'utils/cookie';
import { getCountryCode } from 'utils/localisation';
import { CONSENT_COOKIE_NAME } from 'define/cookies';
import { VISITOR_ID_STORAGE_KEY, PREVIOUS_VISITOR_ID_STORAGE_KEY } from 'define';

// crypto.randomUUID is missing before iOS 15.4
const generateUuid = () => {
  if (crypto.randomUUID) {
    return crypto.randomUUID();
  }

  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');

  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(
    16,
    20,
  )}-${hex.slice(20)}`;
};

export const getVisitorId = () => {
  const savedId = localStorage.getItem(VISITOR_ID_STORAGE_KEY);

  if (savedId) {
    return savedId;
  }

  const visitorId = generateUuid();
  localStorage.setItem(VISITOR_ID_STORAGE_KEY, visitorId);

  return visitorId;
};

const getConsentStatusName = ({ ad_storage, analytics_storage }) => {
  if (ad_storage && analytics_storage) return 'accepted';
  if (ad_storage || analytics_storage) return 'partial';

  return 'rejected';
};

export const getConsentStatus = () => {
  const savedConsent = JSON.parse(getCookie(CONSENT_COOKIE_NAME));

  if (!savedConsent) {
    return { consentStatus: 'pending', consent: null };
  }

  const consent = {
    ad_storage: savedConsent.ad_storage === true,
    analytics_storage: savedConsent.analytics_storage === true,
  };

  return { consentStatus: getConsentStatusName(consent), consent };
};

export const trackVisitor = ({ isPageChange = false } = {}) => {
  if (navigator.webdriver) {
    return;
  }

  const { consentStatus, consent } = getConsentStatus();
  const hasAnalyticsConsent = consent?.analytics_storage === true;

  if (isPageChange && !hasAnalyticsConsent) {
    return;
  }

  const { origin, pathname, search } = window.location;
  const previousVisitorId = localStorage.getItem(PREVIOUS_VISITOR_ID_STORAGE_KEY);

  const data = {
    visitorId: getVisitorId(),
    previousVisitorId,
    url: hasAnalyticsConsent ? `${origin}${pathname}${search}` : null,
    countryCode: getCountryCode() || null,
    gdpr: cookiesStore.theme === 'gdpr',
    consentStatus,
    consent,
  };

  Api.sendVisitorData(data)
    .then(({ status }) => {
      if (status === true && previousVisitorId) {
        localStorage.removeItem(PREVIOUS_VISITOR_ID_STORAGE_KEY);
      }
    })
    .catch(() => {});
};
